import { TFunction } from 'i18next'

import { MissingCustomerDetails } from '@features/invoices/types/missingCustomerDetails'

interface GetMissingCustomerDetailsListSubItemsOptions {
  missingCustomerDetails?: MissingCustomerDetails
  t: TFunction
}

export const getMissingCustomerDetailsListSubItems = ({
  missingCustomerDetails,
  t,
}: GetMissingCustomerDetailsListSubItemsOptions) => {
  const {
    isMissingCustomerCity,
    isMissingCustomerEInvoiceAddress,
    isMissingCustomerPobox,
    isMissingCustomerStreet,
    isMissingCustomerVatNumber,
  } = missingCustomerDetails || {}

  return [
    {
      isMissing: isMissingCustomerCity,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.customer_details.subitem.city',
      ),
    },
    {
      isMissing: isMissingCustomerStreet,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.customer_details.subitem.street',
      ),
    },
    {
      isMissing: isMissingCustomerPobox,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.customer_details.subitem.pobox',
      ),
    },
    {
      isMissing: isMissingCustomerVatNumber,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.customer_details.subitem.vat_number',
      ),
    },
    {
      isMissing: isMissingCustomerEInvoiceAddress,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.customer_details.subitem.e_invoicing_address',
      ),
    },
  ]
    .filter((requirement) => requirement.isMissing)
    .map((requirement) => requirement.label)
}
